// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__xdfoN","file":"styles_file__Jh8ig"};